
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { ArrowLeft, Users } from 'lucide-react';

interface CandidateHeaderProps {
  candidate: any;
  showCandidateList: boolean;
  toggleCandidateList: () => void;
}

const CandidateHeader = ({ candidate, showCandidateList, toggleCandidateList }: CandidateHeaderProps) => {
  const navigate = useNavigate();

  return (
    <>
      <Breadcrumb className="mb-6">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink href="/candidates">Candidates</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink>{candidate.name}</BreadcrumbLink>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      
      <div className="mb-8 flex items-center justify-between">
        <div className="flex items-center">
          {!showCandidateList && (
            <Button 
              variant="ghost" 
              size="sm"
              onClick={toggleCandidateList}
              className="mr-2"
            >
              <Users size={16} className="mr-1" /> 
            </Button>
          )}
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => navigate(-1)}
            className="mr-4"
          >
            <ArrowLeft size={16} className="mr-2" /> Back
          </Button>
          <div className="flex items-center space-x-4">
            <Avatar className="h-12 w-12 border border-border">
              <AvatarImage src={candidate.avatarUrl} alt={candidate.name} />
              <AvatarFallback className="bg-roundone-purple/10 text-roundone-purple">
                {candidate.name.split(' ').map((n: string) => n[0]).join('').toUpperCase()}
              </AvatarFallback>
            </Avatar>
            <div>
              <h1 className="text-2xl font-bold">{candidate.name}</h1>
              <div className="text-sm text-muted-foreground">{candidate.email}</div>
            </div>
          </div>
        </div>
        
        <div>
          <Badge variant="outline" className={candidate.status === 'completed' ? 'bg-green-100 text-green-800 border-green-200' : 'bg-orange-100 text-orange-800 border-orange-200'}>
            {candidate.status === 'completed' ? 'Completed' : 'In Progress'}
          </Badge>
        </div>
      </div>
    </>
  );
};

export default CandidateHeader;
